import { gql } from 'graphql-request'

export namespace JobQueries {
  export const QUERY_KEYS = {
    getJobsList: 'getJobsList',
    getJobDetails: 'getJobDetails',
    getJobTemplates: 'getJobTemplates',
  }

  export function getJobsList() {
    return gql`
      query getJobsList($filter: JobsFilter = { limit: 50 }) {
        jobs(filter: $filter) {
          id
          scheduleDate
          memberName
          completed
          startsAt
          claimedAt
          cancelledAt
          host {
            fullName
          }
          home {
            searchDocument
          }
          jobTemplate {
            name
          }
          market {
            timezone
          }
        }
      }
    `
  }

  export function getJobDetails() {
    return gql`
      query getJobDetails($id: Int!) {
        job(id: $id) {
          id
          createdAt
          startsAt
          startedAt
          scheduleDate
          completedAt
          completed
          status
          memberName
          host {
            fullName
          }
          jobTemplate {
            name
          }
          home {
            unitNumber
            property {
              name
              address1
              marketSegment
            }
          }
          market {
            name
            timezone
          }

          internalNotes
          updatedAt
          claimedAt
          cancelledAt
          description
          comments
        }
      }
    `
  }

  export function getJobTemplates() {
    return gql`
    query getJobTemplates() {
      jobTemplates {
        id
        displayName
        name
        description
      }
    }
  `
  }
}
